module.exports = __webpack_public_path__ + "media/1_3-54.dc92e537.mp3";